import { render } from "./OneDistribution.vue?vue&type=template&id=35a9b242&scoped=true"
import script from "./OneDistribution.vue?vue&type=script&lang=js"
export * from "./OneDistribution.vue?vue&type=script&lang=js"

import "./OneDistribution.vue?vue&type=style&index=0&id=35a9b242&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35a9b242"]])

export default __exports__